export const CommentsInformationFieldNames = {
  Comments: 'comments',
} as const;

export type CommentsInformationFields = {
  [CommentsInformationFieldNames.Comments]?: string;
};

export const CommentsFields: string[] = Object.values(
  CommentsInformationFieldNames,
);
